import type { FlowNodeResultADT } from '@lighthouse/shared'
import { t } from 'i18next'

export const subscriptionMiniProgramMsgStream = async (): Promise<undefined | FlowNodeResultADT> => {
    // throw new Error('不能在搭建端使用stripe支付，请在发布后或预览版中使用。')
    throw new Error(t('cannotMiniProgramSubscribeMsg'))
}

export const subscriptionMiniProgramMsg = async (): Promise<undefined | FlowNodeResultADT> => {
    // throw new Error('不能在搭建端使用stripe支付，请在发布后或预览版中使用。')
    throw new Error(t('cannotMiniProgramSubscribeMsg'))
}
